<script lang="ts">
	// One tab. Muted by default; brand text + a brand underline (overlapping the
	// list's baseline via -mb-px) when bits-ui marks it data-[state=active].
	// NO arbitrary `[..]` values.
	import { Tabs as TabsPrimitive } from "bits-ui";
	import { cn } from "../../../utils.js";

	let {
		ref = $bindable(null),
		class: className,
		...restProps
	}: TabsPrimitive.TriggerProps = $props();
</script>

<TabsPrimitive.Trigger
	bind:ref
	data-slot="tabs-trigger"
	class={cn(
		"relative -mb-px inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap border-b-2 border-transparent px-4 py-2.5 text-sm font-semibold text-muted outline-none transition-colors select-none hover:text-ink focus-visible:ring-2 focus-visible:ring-brand data-[state=active]:border-brand data-[state=active]:text-brand-strong [&_svg]:pointer-events-none [&_svg]:shrink-0",
		className
	)}
	{...restProps}
/>
